import type { FaireProductEntity } from "../../entity_types/product";

export const p_e8cd1ivbfs: FaireProductEntity = {
  token: "p_e8cd1ivbfs",
  type: "product",
  name: "Liquid Light - Fulvic Minerals w/ Antioxidants",
  brandToken: "b_4ce3l13q1j",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/ae30ed29eb3e4145380d9ba5d202f20f2b13faf8ec0e0611dd6c54eeeadfe7e1.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/23b33d76511f466ec2f773507e6fb7db6731f3cb304366d43d0acf2d4ace5b14.jpeg",
    "https://cdn.faire.com/fastly/51df978db8c5205b2800fd1d06bf58f901ee28684dfe3991e050c415f2ec8f64.png",
    "https://cdn.faire.com/fastly/ad93dc3d549837b2d4bf8ebe9a7e8b99f13a0d7e184cf68418315ac2dfda8c5f.png",
    "https://cdn.faire.com/fastly/04b853ac8ebf95a4a5f8288a0aadd2db7e53621c727d22df841fba2e63d98900.png",
    "https://cdn.faire.com/fastly/3f1116619998512472018c2c294584f33cb82891fe438be5e88aef8669d2cb6a.png",
    "https://cdn.faire.com/fastly/98c5367797ce10638a16b83b0d9199976b10a6c9a834a4aaec85f0d2ef367db9.png",
    "https://cdn.faire.com/fastly/4651895959fd9798dde49d8e1eaf3ef5a7fb5b1b15c4928011eb2711a0060d61.png",
  ],
  priceDollars: 34,
  description:
    "Liquid Light - Fulvic Minerals with Antioxidants is crafted from ancient plant deposits, offering a liquid form of recovery and stamina infused with detoxifying electrolytes and antioxidants. This unique formulation provides an abundance of micro and macro minerals, crucial for physiological processes such as oxygen transport, growth, development, repair, bone health, cartilage formation, and maintaining cellular membranes.\n\nLiquid Light is a testament to the purity and potency of nature's offerings, delivering a holistic blend of fulvic minerals that goes beyond conventional supplements. Ideal for those seeking a natural boost, it supports overall well-being and enhances bodily functions with its rich mineral content.\n\nPerfect for retailers and wholesalers, Liquid Light stands out as a high-quality supplement that combines superior nutrition with the natural benefits of fulvic minerals. This product is a standout addition to any health-conscious product line.",
  tags: [],
  msrpDollars: 68,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:30.534Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
